import { Component, OnInit } from '@angular/core'
import { Router } from '@angular/router'

@Component({
  standalone: false,
  selector: 'vs-bulk-order-confirmation',
  templateUrl: './bulk-order-confirmation.component.html',
  styleUrls: ['./bulk-order-confirmation.component.scss'],
})
export class BulkOrderConfirmationComponent implements OnInit {
  constructor(private router: Router) {}
  gotToCart() {
    this.router.navigate(['/cart'])
  }
  ngOnInit(): void {}
}
